/**
 * Export component file to be used on project
 */

import Login from './Login';
export default Login;
